import React from 'react';
import { List, Space, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import {
  ForkOutlined,
  LockOutlined,
  MobileOutlined,
  ProductOutlined,
  QuestionCircleOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { RootState } from 'store/Reducers';



const BurgerMenu = (props: any) => {
  const {userInfoes} = useSelector((state:RootState)=>state.profile)
  const routes = [
    { path: '/hakkimizda', name: 'Hakkımızda', icon: <UserOutlined className="burger-icon" /> },
    { path: '/iletisim', name: 'İletişim', icon: <MobileOutlined className="burger-icon" /> },
    { path: '/sss', name: 'Sıkça Sorulan Sorular', icon: <QuestionCircleOutlined className="burger-icon" /> },
    ...(userInfoes?[
      { path: '/sorunlar-oneriler', name: 'Sorunlar & Öneriler', icon: <ProductOutlined className="burger-icon" /> },
    ]:[]),
   
    { path: '/kisisel-verilerin-korunmasi', name: 'Kişisel Verilerin Korunması', icon: <LockOutlined className="burger-icon" /> },
    { path: '/cerezler', name: 'Çerez Politikası', icon: <ForkOutlined className="burger-icon" /> },
  ];
  const { Text } = Typography;
  const navigate = useNavigate();

  return (
    <List
      dataSource={routes}
      renderItem={(item) => (
        <List.Item
          className="group hover:cursor-pointer burger-item"
          onClick={() => {
            navigate(item.path);
            props.onFinish();
          }}
        >
          <Space align="baseline">
            <span className="group-hover:text-indigo-500">{item.icon}</span>
            <Text className="burger-title group-hover:text-indigo-500">{item.name}</Text>
          </Space>
        </List.Item>
      )}
    />
  );
};

export default BurgerMenu;
